export default __webpack_public_path__ + "be293fb.png";